import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import MaterialTheme from './shared/styles/MaterialTheme';
import { ThemeProvider } from '@mui/material/styles';
import StyledGlobal from './shared/styles/StyledGlobal';
import { CssBaseline } from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import { ToastContainer } from 'react-toastify';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { appInsightsReactPlugin } from 'shared/lib/insights';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <AppInsightsContext.Provider value={appInsightsReactPlugin}>
    <StyledThemeProvider theme={MaterialTheme}>
      <ThemeProvider theme={MaterialTheme}>
        <CssBaseline />
        <StyledGlobal />
        <App />
        <ToastContainer />
      </ThemeProvider>
    </StyledThemeProvider>
  </AppInsightsContext.Provider>,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
